var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 2.57198L9.428 5.40064L2.828 12H0V9.17131L6.6 2.57131V2.57198ZM7.54267 1.62931L8.95667 0.214642C9.08169 0.0896615 9.25122 0.0194511 9.428 0.0194511C9.60478 0.0194511 9.77432 0.0896615 9.89933 0.214642L11.7853 2.10064C11.9103 2.22566 11.9805 2.3952 11.9805 2.57198C11.9805 2.74875 11.9103 2.91829 11.7853 3.04331L10.3707 4.45731L7.54267 1.62931Z",
    fill: "#889096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5e57f30f74f1e2dc3f7498ab1279cfbf.svg";
export { ForwardRef as ReactComponent };